import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState, useMemo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { FilterableTable } from '../components/common';
import { dictionary } from '../lang';
import { getAreas, selectAreas } from '../redux';
import { urlTo } from '../utils';
const columns = [
    {
        align: 'right',
        width: 24,
        text: dictionary.AREA_ID,
        sortable: true,
        id: 'area_id',
    },
    {
        align: 'left',
        text: dictionary.AREA_NAME,
        sortable: true,
        id: 'area_name',
    },
    {
        align: 'right',
        text: dictionary.ACTIVE,
        sortable: true,
        id: 'active_customers',
    },
    {
        align: 'right',
        text: dictionary.INACTIVE,
        sortable: true,
        id: 'inactive_customers',
    },
    {
        align: 'right',
        text: dictionary.QUALIFIED_ADDRESSES,
        sortable: true,
        id: 'qualified_addresses',
    },
    {
        align: 'left',
        width: 24,
        text: '',
        sortable: false,
        id: 'view_map',
    },
    {
        align: 'left',
        width: 24,
        text: '',
        sortable: false,
        id: 'view_polygon',
    },
];
const AreasTable = () => {
    const [searchText, setSearchText] = useState('');
    const [pageSize, setPageSize] = useState(10);
    const [selectedPage, setSelectedPage] = useState(1);
    const [sortParams, setSortParams] = useState({ name: 'area_id', order: 'asc' });
    const dispatch = useDispatch();
    const { areas, total, isLoading } = useSelector(selectAreas);
    const areaRows = useMemo(() => areas.map(({ id, name, activeCustomers, inactiveCustomers, totalQualifiedAddresses, }) => ([
        id,
        name,
        activeCustomers,
        inactiveCustomers,
        totalQualifiedAddresses,
        _jsx(Link, { className: "text-center text-primary-300", to: urlTo('area/:areaId', { areaId: id }), children: dictionary.VIEW_MAP }, `area/${id}`),
        _jsx(Link, { className: "text-center text-primary-300", to: urlTo('area/:areaId/polygons', { areaId: id }), children: dictionary.VIEW_POLYGONS }, `area/${id}/polygons`),
    ])), [areas]);
    const updateTable = useCallback(() => {
        const params = {
            ...(searchText && { search: searchText }),
            sort_by: sortParams.name,
            order: sortParams.order,
            page: selectedPage,
            limit: pageSize,
        };
        dispatch(getAreas.request(params));
    }, [
        dispatch,
        pageSize,
        searchText,
        selectedPage,
        sortParams,
    ]);
    useEffect(() => {
        updateTable();
    }, [updateTable]);
    return (_jsx(FilterableTable, { loading: isLoading, columns: columns, rows: areaRows, pageSize: pageSize, setPageSize: setPageSize, sortParams: sortParams, onSortChange: setSortParams, searchText: searchText, searchPlaceholder: dictionary.SEARCH_AREAS, setSearchText: setSearchText, selectedPage: selectedPage, setSelectedPage: setSelectedPage, totalCount: total }));
};
export default AreasTable;
